import { Box, IconButton, Switch, Tooltip } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PropTypes from 'prop-types';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { Card, Tables } from 'src/shared/components/index';
import { createSearchParams, useNavigate } from 'react-router-dom';
import { Asset } from '../models';
import { I18N, ROLES } from 'src/shared/constants/constants';
import { USER_MANAGEMENT } from 'src/shared/constants/routes';
import { useSelector, useDispatch } from 'react-redux';
import React, { FC, useState, useEffect } from 'react';
import { selectUserState } from 'src/auth/login/services/userSlice';
import { BookingAsset } from 'src/modules/BookingManagement/models';
interface AssetDetailsTableProps {
  inputBookingAssetData: BookingAsset[];

}

const AssetDetailsTable: FC<AssetDetailsTableProps> = ({
  inputBookingAssetData,

}) => {
  const { t } = useTranslation(I18N.DEFAULT);

  const columns: GridColDef[] = [
    {
      field: ' ',
      headerName: ' ',
      sortable: false,
      type: 'string',
      flex: 0.1
    },
    {
      field: 'name',
      headerName: t('name'),
      sortable: false,
      flex: 1,
    },
    {
      field: 'billNo',
      headerName: t('billNo'),
      filterable: false,
      flex: 1
    },
    {
      field: 'mobile',
      headerName: t('mobile'),
      filterable: false,
      flex: 1
    },
    {
      field: 'deliveryDate',
      headerName: t('deliveryDate'),
      filterable: false,
      flex: 2,
      valueGetter: (params) => {
        if (params?.row?.deliveryDate) {
          const date: Date = new Date(params?.row?.deliveryDate);
          return `${date.toLocaleString('en-GB',{hour12: true}) || ''}`;
        }
        return '';
      }
    },
    {
      field: 'returnDate',
      headerName: t('returnDate'),
      filterable: false,
      flex: 2,
      valueGetter: (params) => {
        if (params?.row?.returnDate) {
          const date: Date = new Date(params?.row?.returnDate);
          return `${date.toLocaleString('en-GB',{hour12: true}) || ''}`;
        }
        return '';
      }
    },

    {
      field: 'bookingStatus',
      headerName: t('bookingStatus'),
      sortable: true,
      flex: 1
      // valueGetter: (params) => {
      //   return `${params.row.role.roleName || ''}`;
      // }
    }
  ];

  return (
    <>
      <Card className="mb-24">
        <Tables
          rows={inputBookingAssetData}
          columns={columns}
          checkboxSelection={false}
        />
      </Card>
    </>
  );
};

AssetDetailsTable.propTypes = {
    inputBookingAssetData: PropTypes.array.isRequired
};

AssetDetailsTable.defaultProps = {
    inputBookingAssetData: []
};

export default AssetDetailsTable;

